export default {
  INIT: Symbol('INIT'),
  PENDING: Symbol('PENDING'),
  ERROR: Symbol('ERROR'),
  SUCCESS: Symbol('SUCCESS'),
};
